<template>
    <div>
        <app-contratacao :contratacao="contratacao" v-show="mostrarContratacao">
            <template slot="contratacaoFooter">
                <app-btn-voltar></app-btn-voltar>
            </template>
            <template slot="entregaAcoes" slot-scope="data">
                <span
                    class="text-primary"
                    v-if="$temAcessoView('CRED-FORN-ENTR-01')"
                >
                    <i
                        class="fa fa-info-circle fa-lg icon-button"
                        title="Detalhar"
                        @click.stop="detalharEntrega(data.entregaId)"
                    ></i>
                </span>
            </template>
        </app-contratacao>
        <router-view @obterAtualizacao="obterContratacao()"></router-view>
    </div>
</template>

<script>
import ContratacoesServicos from './ContratacoesServicos'
import Contratacao from '@/app/credenciados/componentes/contratacoes/Contratacao'

export default {
    data() {
        return {
            contratacao: {}
        }
    },

    methods: {
        obterContratacao() {
            this.$store.dispatch('addRequest')
            ContratacoesServicos.obterPorId(
                this.$route.params.contratacaoId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.contratacao = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter contratação!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        detalharEntrega(entregaId) {
            this.$router.push({
                name: 'Credenciado_Entregas_Detalhar',
                params: {
                    entregaId: entregaId
                }
            })
        }
    },

    computed: {
        mostrarContratacao() {
            return this.$route.name == 'Credenciado_Contratacoes_Detalhar'
        }
    },

    created() {
        this.obterContratacao()
    },

    components: {
        AppContratacao: Contratacao
    }
}
</script>
